import { cn } from '@bem-react/classname';

export const cnSlot = cn('Slot');

export const cnExtraSpaceAddon = cnSlot('ExtraSpaceAddon');
